import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { monitorSourcePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { monitorSourceOptions } from '../../constants/monitorSource';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import './index.scss';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function MonitorSourceSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatOptionsMessage } = useLanguage();
  const {
    selects: monitorSourceSelects,
    setSelects: setMonitorSourceSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'monitor_scource',
    options: monitorSourceOptions.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  const { formatMessage } = useIntl();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'monitorSource',
      commonBackInfo(
        { monitor_scource: monitorSourceSelects.map(Number) },
        { [defaultKey]: text },
        { needChangeEntity: true, isNumber: true, isAll },
      ),
    );
  }, [monitorSourceSelects, formatMessage]);

  const invalidValue = useMemo(() => {
    return monitorSourceSelects.map(String);
  }, [monitorSourceSelects]);

  return (
    <div className={`monitor-source-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={monitorSourcePlaceholder[lang]}
        onClear={() => setMonitorSourceSelects([])}
        // buttonItemRender={(item: string) => formatMessage({id: monitorSourceMap[item]})}
        selectOptionsInfo={[invalidValue, setMonitorSourceSelects]}
        options={formatOptionsMessage(monitorSourceOptions)}
        pointKey={FilterButtonPoint.monitorSource}
      ></CustomSelect>
    </div>
  );
}
